module.exports = __webpack_public_path__ + "static/media/transactionPendingIcon.4602873c.svg";